// extracted by mini-css-extract-plugin
export default {"container":"Suppliers_container__4D866","search":"Suppliers_search__NW9Rx"};